import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../../App/ClientSDK'
import { DATE_STANDARD_FORMAT } from '../../../../App/DateFormats'
import { BatchClient } from '../../../../App/Helpers/batchIdHandler/BatchClient'
import {
  IApiBatchResponse,
  IAPIOccupancyRateReport,
  IOccupancyRateReportDashboard,
} from '../../../OccupancyRateReport/Client/IOccupancyRateReport'

import { IOccupancyReportParams } from './interfaces/IOccupancyReprortParams'
import Transformer from './Transformer'

export class Client {
  static delay = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  static getOccupancyReportForDashboard = async ({
    from,
    to,
    batchSetter,
  }: IOccupancyReportParams): Promise<IOccupancyRateReportDashboard[]> => {
    const startAt = from.format(DATE_STANDARD_FORMAT)
    const endsAt = to.format(DATE_STANDARD_FORMAT)

    const response: AxiosResponse<IAPIOccupancyRateReport | IApiBatchResponse> =
      await ClientSDK.instance().get(
        `report/person-occupancy/${startAt}/${endsAt}`,
      )

    if ('batch_id' in response.data) {
      batchSetter.setShowLoader(true)
      const batchResult = await BatchClient.handleBatchId(
        batchSetter,
        response.data.batch_id as string,
      )
      if (batchResult && batchResult.data.status === 'finished') {
        batchSetter.setShowLoader(false)
        const response: AxiosResponse<IAPIOccupancyRateReport> =
          await ClientSDK.instance().get(
            `report/person-occupancy/${startAt}/${endsAt}`,
          )
        return Transformer.transform(response.data)
      }
    } else {
      return Transformer.transform(response.data)
    }
  }
}
